import { SyntheticEvent } from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';

import PhoneIcon from './phone.svg';

import { formatPhoneNumber } from '@/helpers/helpers';

import * as styles from './index.module.scss';

const Card = (props) => {
  const { result, index } = props;

  const getLogo = (profileUrl, name) => {
    let src = '/images/placeholder-logo-1.png';
    try {
      src = `/images/placeholder-logo-${(index % 6) + 1 || '1'}.png`;
    } catch {
      (e) => console.debug(e);
    }

    return (
      <div className={styles['logo-container']}>
        <Image
          src={profileUrl}
          alt={name}
          onError={(event: SyntheticEvent<HTMLImageElement, Event>) => {
            (event.target as HTMLImageElement).src = src;
          }}
          width={72}
          quality={80}
          placeholder="blur"
          blurDataURL="iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z/C/HgAGgwJ/lK3Q6wAAAABJRU5ErkJggg=="
        />
      </div>
    );
  };

  return result.display_phone ? (
    <div className={styles['card']} key={result.profile_id}>
      <div className={styles['main-wrapper']}>
        {getLogo(result.logo_url, result.display_name)}
        <div className={styles['profile-container']}>
          <div className={styles['business-name']}>{result.display_name}</div>
          <div className={styles['address-wrapper']}>{result.location?.city && result.location?.state ? `${result.location.city}, ${result.location.state}` : ''}</div>
          <div className={styles['cta-container']}>
            {result.display_phone && (
              <a className={styles['phone-trigger']} href={`tel:${result.display_phone}`}>
                <PhoneIcon />
                <span className="phone-number">{formatPhoneNumber(result.display_phone)}</span>
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

Card.propTypes = {
  result: PropTypes.object.isRequired,
  showCount: PropTypes.bool
};

Card.defaultPropTypes = {
  showCount: true
};

export default Card;
